var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.has_core_loaded && _vm.layoutType === 'vertical')?_c('Vertical',{attrs:{"layout":_vm.layoutType}},[_vm._t("default")],2):_vm._e(),(_vm.has_core_loaded && _vm.layoutType === 'horizontal')?_c('Horizontal',{attrs:{"layout":_vm.layoutType}},[_vm._t("default")],2):_vm._e(),(_vm.has_core_loaded == false)?_c('LoadingWidget'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }